import { Immutable } from "immer";
import React, { type ReactNode } from "react";

import { IMenuFooter } from "../../utils/menu.interface";

type IProps = Immutable<{
    navFooterEl: IMenuFooter;
}>;

export function NavFooter({ navFooterEl }: IProps): ReactNode {
    let link;
    let imageContent: React.JSX.Element | null = null;
    let customHTMLContent: React.JSX.Element | null = null;

    if (navFooterEl.value.page || navFooterEl.value.external_link) {
        link = navFooterEl.value.page
            ? navFooterEl.value.page.url
            : navFooterEl.value.external_link;
    }

    if (navFooterEl.value.image !== null) {
        if (navFooterEl.value.image.url) {
            imageContent = (
                <div className="main-dropdown-menu__footer__image-container">
                    <img
                        className="main-dropdown-menu__footer__image responsive-img"
                        src={navFooterEl.value.image.url}
                        alt={navFooterEl.value.image.title}
                    />
                </div>
            );
        }
    }

    if (navFooterEl.value.copy) {
        customHTMLContent = (
            <div
                className="main-dropdown-menu__footer__content"
                dangerouslySetInnerHTML={{
                    __html: navFooterEl.value.copy,
                }}
            ></div>
        );
    }

    if (link) {
        // Need link title since content is an image. See #13290
        return (
            <a href={link} className="main-dropdown-menu__footer__item">
                {imageContent}
                {customHTMLContent}
            </a>
        );
    }

    return (
        <div className="main-dropdown-menu__footer__item">
            {imageContent}
            {customHTMLContent}
        </div>
    );
}
